import { render, staticRenderFns } from "./selector-checkboxes.vue?vue&type=template&id=228ee16c&scoped=true&"
import script from "./selector-checkboxes.vue?vue&type=script&lang=js&"
export * from "./selector-checkboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ee16c",
  null
  
)

export default component.exports